import { List, styled } from '@mui/material';

import { useCallback } from 'react';

import { useI18n } from '@app-velocity/i18n';

import { ControlTooltip } from '@app-velocity/ui';

import { ProfileIcon } from '@app-velocity/icons';

import { MessageBus } from '@app-velocity/message-bus';

import { useLogout, useUserData } from '@app-velocity/libs/auth';

const messageBus = new MessageBus('users');
const systemMessageBus = new MessageBus('system');

const StyledProfileButton = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  cursor: 'pointer',
  backgroundColor: 'var(--input-input-background-color)',
  height: theme.constants.headerButtonSize,
  width: theme.constants.headerButtonSize,
  flex: 1,
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

export const ProfileButton = () => {
  const { userId, userEmail } = useUserData();
  const logOut = useLogout();

  const { t } = useI18n();

  const renderTarget = useCallback(
    () => (
      <StyledProfileButton>
        <ProfileIcon />
      </StyledProfileButton>
    ),
    []
  );

  const handleLogout = () => {
    logOut();
  };

  const openEULADialog = () => {
    messageBus.publish('modal:eula:open');
  };

  const openPrivacyDialog = () => {
    messageBus.publish('modal:privacy-policy:open');
  };

  const openSecurityPolicyDialog = () => {
    messageBus.publish('modal:security-policy:open');
  };

  const openSoftwareLicenseDialog = () => {
    messageBus.publish('modal:software-license:open');
  };

  const openFeedbackDialog = () => {
    messageBus.publish('modal:feedback:open');
  };

  const openAboutDialog = () => {
    systemMessageBus.publish('modal:about:open');
  };

  return (
    <ControlTooltip disabled={!userId} renderTarget={renderTarget}>
      <List sx={{ minWidth: 150 }}>
        {userId ? (
          <ControlTooltip.Button label={userEmail || ''} disabled />
        ) : null}
        <ControlTooltip.Button
          onClick={handleLogout}
          label={t('users:auth.log_out')}
        />
        <ControlTooltip.Separator />
        <ControlTooltip.Button
          onClick={openFeedbackDialog}
          label={t('users:share_feedback')}
        />
        <ControlTooltip.Separator />
        <ControlTooltip.Button
          onClick={openEULADialog}
          label={t('shared:eula_agreement')}
        />
        <ControlTooltip.Button
          onClick={openPrivacyDialog}
          label={t('shared:privacy_policy')}
        />
        <ControlTooltip.Button
          onClick={openSecurityPolicyDialog}
          label={t('shared:security_policy')}
        />
        <ControlTooltip.Button
          onClick={openSoftwareLicenseDialog}
          label={t('shared:software_license')}
        />
        <ControlTooltip.Separator />
        <ControlTooltip.Button
          onClick={openAboutDialog}
          label={t('shared:about')}
        />
      </List>
    </ControlTooltip>
  );
};
